// Handle browser Back/Forward navigation
window.addEventListener("popstate", function () {
  fetchCollection(window.location.href);
});

document.addEventListener("click", function (e) {
  const drawer = document.getElementById("FilterDrawer");
  const overlay = document.getElementById("FilterOverlay");
  const toggleBtn = document.getElementById("FilterToggle");

  // OPEN DRAWER
  if (e.target.closest("#FilterToggle")) {
    drawer.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("filter-open");
    toggleBtn.setAttribute("aria-expanded", "true");
  }
  // CLOSE DRAWER
  if (e.target.closest("#FilterClose") || e.target.id === "FilterOverlay") {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("filter-open");
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
  }

  const dropdown = document.getElementById("SortDropdown");
  const trigger = e.target.closest(".select-trigger");

  // TOGGLE DROPDOWN
  if (trigger) {
    dropdown.classList.toggle("open");
    const isOpen = dropdown.classList.contains("open");
    trigger.setAttribute("aria-expanded", isOpen.toString());
  }

  // SELECT SORT OPTION
  if (e.target.matches(".select-options li")) {
    const value = e.target.dataset.value;
    const label = e.target.textContent.trim();

    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", value);

    fetchCollection(url.toString());
    history.pushState({}, "", url);

    // Update UI Elements
    const selected = document.getElementById("SelectedSort");
    if (selected) selected.textContent = label;

    document.querySelectorAll(".select-options li").forEach(li => {
      li.classList.remove("active");
      li.setAttribute("aria-selected", "false");
    });
    
    e.target.classList.add("active");
    e.target.setAttribute("aria-selected", "true");

    dropdown.classList.remove("open");
    document.querySelector(".select-trigger").setAttribute("aria-expanded", "false");
  }

  // CLICK OUTSIDE CLOSE DROPDOWN
  if (!e.target.closest(".custom-select")) {
    if (dropdown && dropdown.classList.contains("open")) {
      dropdown.classList.remove("open");
      const currentTrigger = document.querySelector(".select-trigger");
      if (currentTrigger) currentTrigger.setAttribute("aria-expanded", "false");
    }
  }
});

// AJAX RENDER (SAFE)
function fetchCollection(url) {
  fetch(url)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid = doc.querySelector("#ProductGrid");
      const currentGrid = document.querySelector("#ProductGrid");

      if (newGrid && currentGrid) {
        currentGrid.replaceWith(newGrid);
      }
    });
}

// FILTER SUBMIT
document.addEventListener("submit", function (e) {
  if (e.target.id === "FacetFiltersForm") {
    e.preventDefault();

    const formData = new FormData(e.target);
    const params = new URLSearchParams(formData).toString();
    const url = window.location.pathname + "?" + params;

    fetchCollection(url);
    history.pushState({}, "", url);

    // AUTO CLOSE
    const drawer = document.getElementById("FilterDrawer");
    const overlay = document.getElementById("FilterOverlay");
    const toggleBtn = document.getElementById("FilterToggle");

    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("filter-open");
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    const drawer = document.getElementById("FilterDrawer");
    const overlay = document.getElementById("FilterOverlay");
    const toggleBtn = document.getElementById("FilterToggle");

    if (drawer && drawer.classList.contains("active")) {
      drawer.classList.remove("active");
      overlay.classList.remove("active");
      document.body.classList.remove("filter-open");
      if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
    }
  }
});